import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, BrowserRouter } from 'react-router-dom';
import * as Routers from './RouterNew';
import RoutesUrl from './Routes';
import configureStore from '../store/configureStore';
import initialState from '../store/InitialState.config';

import history from '../utils/History';
import Loader from '../components/containers/Admin/Login.container'
import MainFunction from './MainTenantconfig';

const AppRouter = () => (
  <Provider store={configureStore({ initialState })}>

    <Router history={history}>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path={RoutesUrl.ALL_ROUTES} element={<Routers.ALL_ROUTES />} />
          <Route element={<MainFunction />}>
            <Route path={RoutesUrl.ADMINLOGIN} element={<Routers.LoginContainer />} />



            <Route path={RoutesUrl.ENACH_SIGNDESK} element={<Routers.ENACH_SIGNDESK />} />
            <Route path={RoutesUrl.ENACH_SIGNDESK_MOBILE} element={<Routers.ENACH_SIGNDESK_MOBILE />} />
            <Route path={RoutesUrl.FEEDBACK} element={<Routers.Feedback />} />
            <Route path={RoutesUrl.UPLOAD_DOCUMENT} element={<Routers.UPLOAD_DOCUMENT />} />


            <Route path={RoutesUrl.E_NACH_PAGE} element={<Routers.ENACHPAGE />} />
            <Route path={RoutesUrl.E_NACH_EV_PAGE} element={<Routers.ENACHPAGE />} />
            <Route path={RoutesUrl.E_SIGN_NACH_PAGE} element={<Routers.ENACHPAGE />} />
            <Route path={RoutesUrl.ENACH_BY_CASHFREE} element={<Routers.ENACHPAGE />} />
            <Route path={RoutesUrl.ENACH_BY_CASHFREE_EV} element={<Routers.ENACHPAGE />} />
            <Route path={RoutesUrl.E_SIGN_PAGE} element={<Routers.ESIGNPAGE />} />
            <Route path={RoutesUrl.E_SIGN_PAGE_EV} element={<Routers.E_SIGN_PAGE_EV />} />
            <Route path={RoutesUrl.E_SIGN_PAGE_DIGITAP} element={<Routers.E_SIGN_PAGE_DIGITAP />} />


            <Route path={RoutesUrl.Reference} element={<Routers.Reference />} />

            <Route path={RoutesUrl.E_NACH_PAGE_MOBILE} element={<Routers.EnachMobile />} />
            <Route path={RoutesUrl.E_SIGN_PAGE_MOBILE} element={<Routers.EsignMobile />} />



            <Route path={RoutesUrl.E_NACH_PAGE_CARD} element={<Routers.EnachCardPage />} />
            <Route path={RoutesUrl.E_SIGN_PAGE_CARD} element={<Routers.EsignCardPage />} />

            <Route path={RoutesUrl.SEIGNDESK_REDIRECT_URL} element={<Routers.SEIGNDESK_REDIRECT_URL />} />
            <Route path={RoutesUrl.KYC_FORM} element={<Routers.KYC_FORM />} />
            <Route path={RoutesUrl.KYC_MOBILE} element={<Routers.KYC_MOBILE />} />
            <Route path={RoutesUrl.KYC_SIGNZY} element={<Routers.KYC_SIGNZY />} />
            <Route path={RoutesUrl.KYC_DIGITAP} element={<Routers.KYC_DIGITAP />} />

            <Route path={RoutesUrl.DIGILOCKER_KYC} element={<Routers.DIGILOCKER_KYC />} />

            <Route path={RoutesUrl.KYC_FORM_DIGILOCKER} element={<Routers.KYC_FORM_DIGILOCKER />} />
            <Route path={RoutesUrl.KFS_PAGE} element={<Routers.KFS_PAGE />} />
            <Route path={RoutesUrl.KFS_PAGE_NEW} element={<Routers.KFS_PAGE_NEW />} />
            <Route path={RoutesUrl.LEGAL_NOTICE} element={<Routers.LEGAL_NOTICE />} />
            <Route path={RoutesUrl.ESIGN_REDIRECT_URL} element={<Routers.ESIGN_REDIRECT_URL />} />
            <Route path={RoutesUrl.ESIGN_REDIRECT_DIGITAP_URL} element={<Routers.ESIGN_REDIRECT_DIGITAP_URL />} />
            <Route path={RoutesUrl.KYC_REDIRECT_URL} element={<Routers.KYC_REDIRECT_URL />} />
            {/* <Route path={RoutesUrl.KYC_DIGITAP_REDIRECT_URL} element={<Routers.KYC_REDIRECT_URL />} /> */}
            <Route path={`${RoutesUrl.KYC_DIGITAP_REDIRECT_URL}`} element={<Routers.KYC_DIGITAP_REDIRECT_URL />} />

            <Route path={RoutesUrl.CRIF_URL} element={<Routers.CRIF_URL />} />
            <Route path={RoutesUrl.ESIGN_REDIRECT_URL_EV} element={<Routers.ESIGN_REDIRECT_URL_EV />} />
            <Route path={RoutesUrl.SOA} element={<Routers.SOA />} />
            <Route path={RoutesUrl.SOA_EV} element={<Routers.SOA />} />

            <Route path={RoutesUrl.E_NACH_PAGE_UPI} element={<Routers.ENACHPAGE />} />

            <Route path={RoutesUrl.EV_TVR_URL} element={<Routers.EV_TVR_URL />} />
            <Route path={RoutesUrl.EV_LOANCHECK_URL} element={<Routers.EV_LOANCHECK_URL />} />
            <Route path={RoutesUrl.VIEW_TRANSACTION_RECIEPT} element={<Routers.VIEW_TRANSACTION_RECIEPT />} />
            <Route path={RoutesUrl.UPLOAD_DOCUMENT_REDIRECT} element={<Routers.UPLOAD_DOCUMENT_REDIRECT />} />
            <Route path={RoutesUrl.LOAN_AGGREGEMENT_LINK} element={<Routers.LOAN_AGGREGEMENT_LINK />} />
            <Route path={RoutesUrl.ACCOUNT_AGGREGAOTR_LINK} element={<Routers.ACCOUNT_AGGREGAOTR_LINK />} />

          </Route>
        </Routes>
      </Suspense>
    </Router>

  </Provider >
)


export default AppRouter;
